<div>
        <mat-label class="font-weight-400">{{label}}</mat-label>

        <button mat-raised-button
                [disabled]="downloading"
                (click)="downloadTemplate()"
                *ngIf="!readonly"
                class="mr-3">
            Download
        </button>
        <button mat-raised-button color="primary"
                [disabled]="ngControl.disabled"
                *ngIf="!readonly"
                (click)="fileUploader.openSelectFile()"
                class="ml-8"><mat-icon>file_upload</mat-icon> {{'BUTTONS.ATTACH' | translate}}</button>

        <app-simple-file-uploader class="uploader"
                                  #fileUploader
                                  [initialData]="initialData"
                                  [endpoint]="uploadEndpoint"
                                  [allowedExtensions]="allowedExtensions">
            <div class="uploader-content mt-3">
                <div style="display: flex;">
                  <table mat-table [dataSource]="matDatasource" class="mat-elevation-z5" [ngStyle]="{ width: '100%' }"><!-- [ngStyle.gt-xs]="'width:100%'" -->
                    <ng-container matColumnDef="name">
                      <th style="width: 200px;" mat-header-cell *matHeaderCellDef> {{"FILE-MANAGER.TABLE.NAME" | translate}} </th>
                      <td mat-cell *matCellDef="let file"> {{file.name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                      <th style="width: 200px;" class="d-none d-lg-table-cell" mat-header-cell *matHeaderCellDef> {{"FILE-MANAGER.TABLE.TYPE" | translate}} </th>
                      <td mat-cell class="d-none d-lg-table-cell" *matCellDef="let file"> {{file.mimeType}} </td>
                    </ng-container>
                    <ng-container matColumnDef="size">
                      <th style="width: 200px;" class="d-none d-lg-table-cell" mat-header-cell *matHeaderCellDef> {{"FILE-MANAGER.TABLE.SIZE" | translate}} </th>
                      <td mat-cell class="d-none d-lg-table-cell" *matCellDef="let file"> {{file.fileLength}} </td>
                    </ng-container>
                    <ng-container matColumnDef="remove">
                      <th style="width: 200px;" mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let file">
                        <button mat-icon-button
                                *ngIf="!ngControl.disabled"
                                (click)="fileUploader.removeFile(file)"><mat-icon>cancel</mat-icon></button>
                        <button mat-icon-button
                                (click)="fileUploader.downloadFile(file)"><mat-icon>get_app</mat-icon></button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                </div>
            </div>
            <div class="uploading-overlay" *ngIf="fileUploader.filesStatus?.length">
                <div class="uploading-video-data" *ngFor="let upload of fileUploader.filesStatus">
                    <!-- <mat-progress-bar style="grid-area: progress; margin: auto;"
                                      color="accent"
                                      *ngIf="upload.progress"
                                      [mode]="'buffer'"
                                      [value]="upload.status == 1 ? null : upload.progress" >
                    </mat-progress-bar> -->
                    <mat-spinner [diameter]="35"></mat-spinner>
                </div>
            </div>
        </app-simple-file-uploader>


<!--        <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">-->
<!--            <input matInput [formControl]="ngControl.control"-->
<!--                [placeholder]="placeholder"-->
<!--                [type]="inputType"-->
<!--                #textInput>        -->
<!--            -->

<!--            -->
<!--            &lt;!&ndash; errors &ndash;&gt;-->
<!--            &lt;!&ndash; <mat-hint *ngIf="ngControl.control.errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.email">{{'AUTH.VALIDATION.INVALID_EMAIL' | translate}} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.maxlength">{{'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.max">{{'AUTH.VALIDATION.MAX_VALUE' | translate }} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.min">{{'AUTH.VALIDATION.MIN_VALUE' | translate }} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.pattern">{{'AUTH.VALIDATION.BAD_FORMAT' | translate }} &nbsp;</mat-hint>-->
<!--            <mat-hint *ngIf="ngControl.control.errors?.blankSpaces">{{'AUTH.VALIDATION.BLANK_FIELD' | translate }} &nbsp;</mat-hint> &ndash;&gt;-->
<!--            -->
<!--        </mat-form-field>-->
            
        <ng-container *ngIf="ngControl.control.valid">
            <div fxLayout="row" fxLayoutAlign="flex-end" class="input-text-hint">
<!--                <mat-hint>{{textInput.value.length}} / {{maxLength}}</mat-hint>-->
            </div> 
        </ng-container>
        <ng-container *ngIf="ngControl.touched">
            <mat-error *ngIf="ngControl.control.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
            <mat-error *ngIf="ngControl.control.hasError('email')">{{'INPUT.INVALID_EMAIL' | translate}}</mat-error>
            <mat-error *ngIf="ngControl.control.hasError('maxLength')">{{'INPUT.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}}</mat-error>
            <mat-error *ngIf="ngControl.control.hasError('max')">{{'INPUT.MAX_VALUE' | translate }}</mat-error>
            <mat-error *ngIf="ngControl.control.hasError('min')">{{'INPUT.MIN_VALUE' | translate }}</mat-error>
            <mat-error *ngIf="ngControl.control.hasError('pattern')">{{'INPUT.BAD_FORMAT' | translate }}</mat-error>

        </ng-container>
<!--    <ng-container *ngIf="ngControl.control.disabled">-->
<!--        <mat-label class="font-weight-400">{{label}}</mat-label>-->
<!--        <p style="font-weight: bold;" *ngFor="let file of initialData">{{file.name}}</p>-->
<!--    </ng-container>-->
</div>
